import { render, staticRenderFns } from "./editDef.vue?vue&type=template&id=68ae5d75&scoped=true"
import script from "./editDef.vue?vue&type=script&lang=js"
export * from "./editDef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae5d75",
  null
  
)

export default component.exports